import { FlagIcon } from "react-flag-kit";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import logoPNG from "../../assets/images/lingo_small.png";

import {
  Container,
  BestSeller,
  LogoLingo,
  NamePlan,
  WrapperIconsLanguages,
  DescriptionPlans,
  DiscountPercent,
  PriceBase,
  PricePlans,
  Month,
  ButtonSelect,
} from "./styles";

const CardPlans = ({ data, selectedPlanId, changeType, cpn }) => {
  const { t } = useTranslation();

  const parts = data?.final_value.toString().split(".");
  const cents = parts.length > 1 ? parts[1] : "00";
  const currency = data?.currency === "BR" ? "R$" : "USD";

  const cpnURL = cpn !== "" ? `&cpn=${cpn}` : "";

  const { language } = useSelector((state) => state.userReducer);

  const calculateHoursMonth = (totalClasses, unlimited) => {
    if (unlimited) {
      return language === "en"
        ? "Unlimited Classes"
        : language === "es"
        ? "Clases Ilimitadas"
        : language === "pt"
        ? "Aulas Ilimitadas"
        : language === "fr"
        ? "Unlimited Classes"
        : "Unlimited Classes";
    }

    return `(${totalClasses / 2} ${t("HOURS")} ${t("PER_MONTH")}) `;
  };

  return (
    <Container>
      {data?.bestSeller && (
        <BestSeller className="bestSeller">
          <span>{t("BEST_SELLER")}</span>
        </BestSeller>
      )}

      <LogoLingo src={logoPNG} />

      <NamePlan>
        {language === "en"
          ? data?.nameEnglish
          : language === "es"
          ? data?.nameSpanish
          : language === "pt"
          ? data?.namePortuguese
          : language === "fr"
          ? data?.nameFrench
          : data?.nameEnglish}
      </NamePlan>

      <WrapperIconsLanguages>
        {data?.languageUS && <FlagIcon code="US" />}
        {data?.languageBR && <FlagIcon code="BR" />}
        {data?.languageES && <FlagIcon code="ES" />}
        {data?.languageFR && <FlagIcon code="FR" />}
        {data?.multiLingo && (
          <>
            <FlagIcon code="US" />
            <FlagIcon code="BR" />
            <FlagIcon code="ES" />
            <FlagIcon code="FR" />
          </>
        )}
      </WrapperIconsLanguages>

      <DescriptionPlans>
        <p>
          {language === "en"
            ? data?.descriptionEnglish
            : language === "es"
            ? data?.descriptionSpanish
            : language === "pt"
            ? data?.descriptionPortuguese
            : language === "fr"
            ? data?.descriptionFrench
            : data?.descriptionEnglish}
        </p>
        <p>{calculateHoursMonth(data?.totalClasses, data?.unlimited)}</p>
      </DescriptionPlans>

      {data?.discount_percent !== 0 && (
        <>
          <DiscountPercent>{data?.discount_percent} % Off</DiscountPercent>
          <PriceBase>
            {currency} {data?.baseValue.toFixed(2).replace(".", ",")}
          </PriceBase>
        </>
      )}

      <PricePlans>
        <span>{currency}</span> {parts[0]} <span>, {cents}</span>
      </PricePlans>

      <Month discount={data?.discount_percent !== 0 ? "true" : "false"}>
        {t("PER_MONTH")} <span>{t("BILLED_MONTHLY")}</span>
      </Month>

      <ButtonSelect
        target="_top"
        rel="noreferrer"
        href={`/checkout?${
          data?.link_made
        }&partner=null&studentPlanId=${selectedPlanId}&changeType=${changeType}${cpnURL}&currency=${
          currency === "R$" ? "BRL" : "USD"
        }&internalCheckout=true`}
      >
        {t("SELECT")}
      </ButtonSelect>
    </Container>
  );
};

export default CardPlans;
